/**
 * Sets the document title and <meta name="description"> for the current page.
 * Runs client-side and is captured by scripts/prerender.mjs into the static HTML,
 * so each route ships its own title/description for search engines.
 */
const SITE_URL = 'https://ps155m.org';

export function setPageMeta({ title, description, path }) {
  if (title) {
    document.title = title;
  }
  if (description) {
    let tag = document.querySelector('meta[name="description"]');
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute('name', 'description');
      document.head.appendChild(tag);
    }
    tag.setAttribute('content', description);
  }
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    document.head.appendChild(canonical);
  }
  canonical.setAttribute('href', `${SITE_URL}${path ?? window.location.pathname}`);
}
